// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Ge7K","title":"Images90_title__2GsYr","images":"Images90_images__3t3De"};